import DealerStockoutPanel from "./dealerStockoutPanel.container"

export default DealerStockoutPanel
